import { Button, Stack, Typography } from '@ace-clublabs/shared-component-library';

export interface IWTButtonProps {
  title: string;
  onClick: () => void;
  hidden?: boolean;
  id?: string;
  className?: string;
  titleFontSize?: string;
  variant?: 'small';
}

export const IWTButton = ({ id, className, title, onClick, hidden, variant }: IWTButtonProps) => {
  return (
    <div id={id} className={className} onClick={onClick} hidden={hidden}>
      <Stack sx={{ margin: '0px 8px 8px 0px' }} gap={'8px'}>
        <Button
          label={
            <Typography
              sx={{
                color: '#1C4DA6',
                fontSize: variant === 'small' ? '0.875rem !important' : '1rem !important',
                whiteSpace: 'nowrap',
              }}
              align="center"
            >
              {title}
            </Typography>
          }
          onClick={() => {}}
          className="iwt-card-button"
          variant="outlined"
          sx={{
            color: 'blue',
            backgroundColor: '#FFFFFF',
            borderRadius: '12px',
            padding: variant === 'small' ? '7px 9px !important' : '9px !important',
            // minWidth: '200px',
          }}
        />
      </Stack>
    </div>
  );
};
